/**
 * Labstep
 *
 * @module components/EntityImport/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { EntityImportActionDeleteProps } from './types';

export const EntityImportActionDelete: React.FC<
  EntityImportActionDeleteProps
> = ({ entity }) => <EntityActionDelete entity={entity} />;
